/**
 * useAccess — hook qui interroge GET /api/access/me et fournit l'état paywall
 * + un helper `handlePaywallError(err)` qui détecte un 402 et déclenche le modal.
 */
import { useEffect, useState, useCallback } from 'react';
import { api } from '../context/AppContext';

export const useAccess = () => {
  const [access, setAccess] = useState(null);
  const [paywallOpen, setPaywallOpen] = useState(false);
  const [paywallReason, setPaywallReason] = useState('');

  const fetchAccess = useCallback(async () => {
    try {
      const res = await api.get('/access/me');
      setAccess(res.data);
    } catch {
      // silent — paywall logic is server-authoritative anyway
    }
  }, []);

  useEffect(() => { fetchAccess(); }, [fetchAccess]);

  const handlePaywallError = useCallback((err) => {
    if (err?.response?.status === 402) {
      const detail = err.response.data?.detail || {};
      setPaywallReason(detail.message || '');
      setPaywallOpen(true);
      return true;
    }
    return false;
  }, []);

  return {
    access,
    paywallOpen,
    paywallReason,
    setPaywallOpen,
    handlePaywallError,
    refresh: fetchAccess,
  };
};
